var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGeorgia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M247.229,163.389h-9.804c0,0-1.088-4.811-2.904-10.986c-1.814-6.171-10.895-9.078-10.895-9.078 c-4.717-12.708-9.441-22.15-19.608-28.324c-10.167-6.172-13.798-11.62-18.155-16.703c-4.357-5.083-20.698-15.977-20.698-15.977 l-14.523-23.24c0,0-4.509,0-5.944,0c-0.088,0-0.167,0-0.231,0c-1.089,0-11.256-5.444-13.799-9.078 c-1.792-2.56,1.827-8.359,4.12-11.565c0.962-1.343,1.69-2.234,1.69-2.234l-46.843,4.722l-36.854,5.332l-12.076,1.749 c0,0,1.908,13.073,1.908,14.979c0,1.907,5.445,14.16,7.352,18.52c1.905,4.356,17.702,67.267,20.152,73.804 c2.453,6.535,11.167,17.975,12.53,20.424c1.36,2.453-1.907,3.815-3.815,9.531c-1.739,5.227-1.206,14.545,0.354,25.25 c0.146,1.017,0.299,2.039,0.463,3.076c1.907,11.979,5.992,23.42,5.992,23.42s6.9,12.708,8.715,13.8 c1.817,1.089,109.663-6.538,109.663-6.538l0.726,8.354h6.174l1.816-8.715l-3.633-11.257l2.904-2.54l21.428,2.54 c0,0,0-12.347,1.088-21.788c1.09-9.441,7.262-22.877,7.262-22.877l-2.179-6.173l7.625-14.252V163.389z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeorgia);
export default __webpack_public_path__ + "static/media/georgia.db21d38f44dcaaf879b7cc6179776d17.svg";
export { ForwardRef as ReactComponent };